import { handleActions } from 'redux-actions';
import { GET_WORKER_SKILLS_SUCCESS, GET_WORKER_DETAILS_SUCCESS, CLEAR_WORKER_DETAILS, GET_WORKER_JOBS_SUCCESS,
  GET_WORKER_QUICK_VIEW_START, GET_WORKER_QUICK_VIEW_ERROR, GET_WORKER_QUICK_VIEW_SUCCESS, CLEAR_WORKER_QUICK_VIEW, GET_WORKER_JOBS_COMPLETED_SUCCESS } from '../actions/actionTypes';

const initialState = {
  jobsList: [],
  pagesQuantity: 0,
  workerDetails: {},
  workerSkills: [],
  workerQuickView: {},
  isLoading: false,
  error: null
};

export default handleActions(
  {
    [GET_WORKER_SKILLS_SUCCESS]: (state, action) => ({
      ...state,
      workerSkills: action.workerSkills
    }),
    [GET_WORKER_DETAILS_SUCCESS]: (state, action) => ({
      ...state,
      workerDetails: action.payload
    }),
    [CLEAR_WORKER_DETAILS]: (state) => ({
      ...state,
      workerDetails: {}
    }),
    [GET_WORKER_JOBS_SUCCESS]: (state, action) => ({
      ...state,
      jobsList: action.jobsList,
      pagesQuantity: action.pagesQuantity
    }),
    [GET_WORKER_QUICK_VIEW_START]: (state) => ({
      ...state,
      isLoading: true,
      error: null
    }),
    [GET_WORKER_QUICK_VIEW_SUCCESS]: (state, action) => ({
      ...state,
      isLoading: false,
      workerQuickView: action.data
    }),
    [GET_WORKER_QUICK_VIEW_ERROR]: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.error
    }),
    [CLEAR_WORKER_QUICK_VIEW]: (state) => ({
      ...state,
      workerQuickView: initialState.workerQuickView
    }),
    [GET_WORKER_JOBS_COMPLETED_SUCCESS]: (state, action) => ({
      ...state,
      workerDetails: {
        ...state.workerDetails,
        jobs: action.jobs
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/worker.js